import './ProjectCard.scss'

import ThumbTack from "../../assets/icons/thumbtack.svg"
import ThumbTackBack from "../../assets/icons/thumbtack-back.svg"
import ExternalLink from "../../assets/icons/external-link.svg"
import SmallGitHub from "../../assets/icons/lucide-line-icons/github-lucide-line-icons.svg"

import { useState, useEffect } from 'react'

function ProjectCard({ projectName, projectTitle, projectDescription, projectTechStack, projectExtLink, projectGitHub, projectTimestamp, projectCaseStudyDone }) {

  const [image, setImage] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await import(`../../assets/images/Project-${projectName}/demo.png`)
        setImage(response.default)
      } catch (err) {
        setError(err)
      }
    }

    fetchImage()
  }, [projectName])

  if (!projectName || !projectTitle || !projectDescription || !projectTechStack) {
    return (
      <div className='card'>
        <img className='card__thumbtack-back' src={ThumbTackBack} alt="project tag" />
        <img className='card__thumbtack' src={ThumbTack} alt="project tag" />
        <div className='card__container-error'>
          <div className='card__bg-error'></div>
        </div>
      </div>
    )
  }

  return (

    <div className='card'>
      <img className='card__thumbtack-back' src={ThumbTackBack} alt="project tag" />
      <img className='card__thumbtack' src={ThumbTack} alt="project tag" />
      {/* <div className='position-check'></div> */}
      <div className='card__container'>
        {projectCaseStudyDone 
          ? <a className='card__case-study' href={`./${projectName}`}>Case Study</a>
          : <a className='card__case-study' href="./under-construction">Case Study</a>
        }
        <div className='card__bg'>
          {!error && <img src={image} className="card__preview" alt="project preview" />}
        </div>
        <div className='card__header'>
          <div className='card__top'>
            <ul className='card__link-list'>
              {projectExtLink.length > 0 &&
                <li className='card__link-items'>
                  <a target="_blank" rel="noreferrer" href={projectExtLink} className="social__external-link">
                    <img src={ExternalLink} alt="external link" className="card__external-link" />
                  </a>
                </li>
              }
              {projectGitHub.length > 0 &&
                <li className='card__link-items'>
                  <a target="_blank" rel="noreferrer" href={projectGitHub} className="social__github-link">
                    <img src={SmallGitHub} alt="github link" className="card__github" />
                  </a>
                </li>
              }
            </ul>
          </div>
          <div className='card__title'>
            <h3 className='card__name'>{projectTitle}</h3>
            <span className='card__timestamp'>{projectTimestamp}</span>
          </div>

          <p className='card__description'>
            {projectDescription}
          </p>
        </div>
        <div className='card__footer'>
          <ul className='card__tech-stack-list'>
            {projectTechStack.map((item, index) => {
              return <li key={index} className='card__tech-stack-items'>{item}</li>
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default ProjectCard